import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlanCheckedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 12,
			fill: "url(#paint0_linear_237_15029)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 12.5L10.5 15.5L16.5 9.5",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_237_15029",
			x1: 12,
			y1: 143051e-11,
			x2: 12,
			y2: 24,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF537F" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#641EDC"
			})]
		}) })
	]
});
export default SvgPlanCheckedIcon;
